import clsx from 'clsx';

export const Panel = ({ category = 'default', height = 'full', width = 'full', rounded=false, title, children, className, noPadding, subTitle, noHeader }) => {
  const getBackgroundColor = () => {
    if (category === 'default') {
      return 'bg-perception-black-800';
    } else if (category === 'main') {
      return 'bg-perception-black-900';
    } else if (category === 'secondary') {
      return 'bg-perception-black-500';
    }
  };

  const getHeight = () => height === 'full' ? 'h-full' : height;
  const getWidth = () => width === 'full' ? 'w-full' : width;

  const getRounded = () => rounded ? 'rounded-md' : '';

  return (
    <div className={clsx('panel', getBackgroundColor(), getHeight(), getWidth(), getRounded(), 'flex flex-col relative overflow-y-auto', className)}>
      {!noHeader && <HeaderPanel title={title} subTitle={subTitle} />}
      <div className={`${noPadding ? '' : 'py-4 px-4'} h-full w-full flex flex-col text-perception-gray-500 overflow-y-auto`}>{children}</div>
    </div>
  );
};

const HeaderPanel = ({ title, subTitle }) => {
  return (
    <div className='bg-perception-gray-800 flex justify-between px-4 py-[0.15rem] w-full'>
      <span className='text-white text-xs'>{title}</span>
      {
        subTitle && <span className='text-white text-xs'>{subTitle}</span>
      }
    </div>
  );
};
